module.exports = __webpack_public_path__ + "img/logo_mob.d0c63a44.svg";